import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Users, Building2, ClipboardCheck, GraduationCap } from "lucide-react";
import { Card } from "antd";
import { useNavigate } from "react-router-dom";
import { getEmployeeCount } from "../../../../../redux/overview/overviewState";

const DashboardSummaryCard = ({ employeeCount, getEmployeeCount }) => {
  const navigate = useNavigate();

  useEffect(() => {
    getEmployeeCount(); 
  }, [getEmployeeCount]);

  const DASHBOARD_CARDS = [
    {
      title: "Total Employees",
      value: employeeCount?.data?.count ?? "0",
      description: `Active: ${employeeCount?.data?.active ?? 0}`,
      route: "",
      icon: Users,
      iconBg: "gradient-purple",
      gradient: "purple-green",
    },
    {
      title: "Client Organizations",
      value: "12",
      description: "Active Partnerships",
      route: "",
      icon: Building2,
      iconBg: "gradient-blue",
      gradient: "blue-cyan",
    },
    {
      title: "Teams & Departments",
      value: "8",
      description: "All Active",
      route: "",
      icon: ClipboardCheck,
      iconBg: "gradient-emerald",
      gradient: "green-teal",
    },
    {
      title: "Training Completion",
      value: "8",
      description: "Available Courses",
      route: "",
      icon: GraduationCap,
      iconBg: "gradient-red",
      gradient: "red-orange",
    },
  ];

  const handleClick = (route) => {
    if (route) navigate(route);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {DASHBOARD_CARDS.map((card, index) => {
        const Icon = card.icon;
        return (
          <Card
            key={index}
            onClick={() => handleClick(card.route)}
            className="flex flex-col gap-6 rounded-xl cursor-pointer hover:shadow-lg transition-all border border-slate-200 dark:border-zinc-700 dark-mode-card"
          >
            <div className="flex items-center justify-between">
              <div>
                <h4 className="text-xs muted-text uppercase">{card.title}</h4>
                <div className={`text-[32px] font-semibold label-gradient ${card.gradient}`}>
                  {card.value}
                </div>
                <p className="text-[12px] muted-text">{card.description}</p>
              </div>
              <div className={`p-2 gradient-icon bg-text !rounded-full ${card.iconBg}`}>
                <Icon className="w-7 h-7" />
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
};

const mapStateToProps = (state) => ({
  employeeCount: state.overview.employeeCount,
});

const mapDispatchToProps = (dispatch) => ({
  getEmployeeCount: () => dispatch(getEmployeeCount()),
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardSummaryCard);